const currencies = [
    { id: 1, value: 'USD', label: '$' },
    { id: 2, value: 'EUR', label: '€' },
    { id: 3, value: 'GBP', label: '£' },
];

export default currencies;
